import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './App.css';
import NavBar from './components/navbar';
import ResponsiveDrawer from './components/responsiveDrawer';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import clsx from 'clsx';
import SignInSide from './components/signInSidePage';
// import SignUpSide from './components/signUpSidePage';
import VerifyEmail from './components/verifyEmail';
import ForgotPassword from './components/forgotPassword';
import ResetPassword from './components/resetPassword';
import SetPassword from './components/setPassword';
import NotFound from './components/notfound';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { AlertTitle } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import { useSnackbar } from 'notistack';
// import BusinessCard from './components/businessCard';
import { w3cwebsocket as W3CWebSocket } from "websocket";
import config from './config.json';
import { Message } from "react-chat-ui";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import ResetPasswordFromForgot from "./components/resetPasswordFromForgot";
import axios from 'axios';
import TipJar from './components/tipJar';
import Users from './components/users';
import Invites from './components/invites';
import PushNotifications from './components/pushnotifications';
import PromotionInvites from './components/promotionInvites';

const queryString = require('query-string');

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function App(props) {
  const dir = document.getElementsByTagName('html')[0].getAttribute('dir');

  const fullScreenHandle = useFullScreenHandle();

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [refreshUI, setRefreshUI] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [showSalesVideoCallNotification, setShowSalesVideoCallNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createBusinessCard, setCreateBusinessCard] = useState(false);
  const history = useHistory();
  const [businessCardStep, setBusinessCardStep] = useState(1);
  const [showMentorVideo, setShowMentorVideo] = useState(false);
  const [showSalesVideoCall, setShowSalesVideoCall] = useState(false);
  const [showNetworkingVideo, setShowNetworkingVideo] = useState(false);
  const [roomName, setRoomName] = useState(null);
  const [chatMessages, setChatMessages] = useState({});
  const [newMessages, setNewMessages] = useState([]);
  const [webSocketClient, setWebSocketClient] = useState(null);
  const [isMentor, setIsMentor] = useState(false);
  const [isExhibitor, setIsExhibitor] = useState(false);
  const [isAttendee, setIsAttendee] = useState(false);
  const [isSalesMen, setIsSalesMen] = useState(false);

  const [superAdminRole, setSuperAdminRole] = useState(false);
  const [adminRole, setAdminRole] = useState(false);
  const [warehouseRole, setWarehouseRole] = useState(false);
  const [procurementRole, setProcurementRole] = useState(false);
  const [projectManagerRole, setProjectManagerRole] = useState(false);
  const [engineeringManagerRole, setEngineeringManagerRole] = useState(false);
  const [supervisorRole, setSupervisorRole] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedUOM, setSelectedUOM] = React.useState(null);
  const [selectedSupplyVendor, setSelectedSupplyVendor] = React.useState(null);
  const [selectedServiceVendor, setSelectedServiceVendor] = React.useState(null);
  const [selectedProject, setSelectedProject] = React.useState(null);
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);

  const [pingTimer, setPingTimer] = useState(null);
  const [mentorAppliedRequests, setMentorAppliedRequests] = useState([]);
  const [mentorRequests, setMentorRequests] = useState([]);
  const [salesCallRequests, setSalesCallRequests] = useState([]);
  const [inProcessUser, setInProcessUser] = useState(null);
  const [videoCallWaiting, setVideoCallWaiting] = useState(false);
  const [videoCallWaitingQueueSize, setVideoCallWaitingQueueSize] = useState(0);
  const [videoCallWaitingQueuePosition, setVideoCallWaitingQueuePosition] = useState(0);
  const [currentExhibitorStallInfo, setCurrentExhibitorStallInfo] = useState(null);
  const [salesVideoCallMembers, setSalesVideoCallMembers] = useState([]);
  const [salesVideoCallMembersNames, setSalesVideoCallMembersNames] = useState([]);
  const [salesPersonCalling, setSalesPersonCalling] = useState(null);
  const [salesPersonCallingName, setSalesPersonCallingName] = useState(null);

  const [productCategories, setProductCategories] = React.useState(null);
  const [UOMs, setUOMs] = React.useState(null);
  const [customers, setCustomers] = React.useState([]);
  const [projects, setProjects] = React.useState([]);
  const [warehouses, setWarehouses] = React.useState([]);

  const [project, setProject] = React.useState(null);
  const [procurement, setProcurement] = React.useState(null);

  const [verifyEmailMode, setVerifyEmailMode] = React.useState(false);
  const [forgotPasswordMode, setForgotPasswordMode] = React.useState(false);
  const [token, settoken] = React.useState(null);
  const [username, setusername] = React.useState(null);
  const [paypalMode, setPaypalMode] = React.useState(false);

  const left = !drawerOpen ? '72px' : '240px';
  const right = !drawerOpen ? '72px' : '240px';
  const leftM = !drawerOpen ? '52px' : '240px';
  const rightM = !drawerOpen ? '52px' : '240px';

  const useStyles = makeStyles((theme) => ({

    root: {
      flexGrow: 1,
    },
    open: {
      width: "calc(100vw - 240px)",
      position: "relative",
      '@media (max-width: 600px)': {
        width: "calc(100vw - 52px)",
      }
    },
    close: {
      width: "calc(100vw - 72px)",
      position: "relative",
      '@media (max-width: 600px)': {
        width: "calc(100vw - 52px)",
      }
    },
    left: {
      left: left,
      '@media (max-width: 600px)': {
        left: leftM
      }
    },
    right: {
      right: right,
      '@media (max-width: 600px)': {
        right: rightM
      }
    },
    fab: {
      position: 'absolute',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  }));
  const classes = useStyles();

  const themeChanged = () => {
    console.log("themeChangedInApp");
    setRefreshUI(false);

    setTimeout(() => {
      setRefreshUI(true);
    }, 10);
  };

  const openWebSocketConnect = () => {
    closeWebSocketConnection();
    let profileData = JSON.parse(window.localStorage.getItem("profile"));
    console.log(profileData);
    const fullUrl = config["websocketurl"];// + profileData["user_id"];
    console.log(fullUrl);
    const newClient = new W3CWebSocket(fullUrl);
    const pingData = { "action": "sendmessage", "payload": { "to": profileData["user_id"], "body": "ping", "type": "chat" } };

    setWebSocketClient(newClient);
    newClient.onopen = () => {
      console.log('WebSocket Client Connected');
      console.log("client.readyState: ", newClient.readyState);

      // newClient.send(JSON.stringify({ "action": "presence", "payload": { "action": "subscribe" } }));

      let timer = setInterval(async () => {
        try {
          await Auth.currentAuthenticatedUser();
          newClient.send(JSON.stringify(pingData));
        }
        catch (error) {
          console.log("Error: ", error);
        }
      }, 60000);

      setPingTimer(timer);
    };
    newClient.onclose = (event) => {
      console.log("WebSocket is closed now.: ", event);

      setTimeout(() => {
        openWebSocketConnect();
      }, 2000);
    };
    newClient.onmessage = (message) => {
      console.log(message.data);
      const jsonData = JSON.parse(message.data);
      console.log(jsonData["action"]);
      switch (jsonData["action"]) {

        case "auth":
          const data = { "action": "auth", "payload": { "user_id": profileData["user_id"], "user_name": (profileData["name"] ? profileData["name"] : "") } };
          console.log(data);
          newClient.send(JSON.stringify(data));
          break;

        case "presence":
          // console.log(jsonData["payload"]["action"]);
          if (jsonData["payload"]["action"] === "status") {
            if (jsonData["payload"]["type"] === "online") {
              console.log(jsonData["payload"]["from"] + "  came online");
              //props.onUserCameOnline(jsonData["payload"]["from"]);
            }
            else {
              console.log(jsonData["payload"]["from"] + "  went offline");
              //props.onUserWentOffline(jsonData["payload"]["from"]);
            }
          }
          else if (jsonData["payload"]["action"] === "roster") {
            console.log(jsonData["payload"]["members"]);
          }
          break;

        case "sendmessage":
          if (jsonData["payload"]["type"] === "chat") {
            if (jsonData["payload"]["body"] === "ping") {
              // Its a ping message
              console.log("Ping");
            }
            else {
              // let messages = { ...chatMessages };
              //console.log("before: ", chatMessages);
              if (chatMessages[jsonData["payload"]["from"]] === undefined)
                chatMessages[jsonData["payload"]["from"]] = [];

              const msg = new Message({ id: 1, message: jsonData["payload"]["body"] });
              chatMessages[jsonData["payload"]["from"]].push(msg);

              const msgs = [...chatMessages[jsonData["payload"]["from"]]];
              setNewMessages(msgs);

              showNotificationForNewChatMessage("New : " + jsonData["payload"]["body"]);
            }
          }
          break;
        case "mentor":
          if (jsonData["payload"]["type"]) {
            if (jsonData["payload"]["type"] === "accept") {
              // jsonData["payload"]["mentor"]

              setShowNotification(true);
            }
            else if (jsonData["payload"]["type"] === "reject") {
              // getListOfAppliedMentoring();
            }
            else if (jsonData["payload"]["type"] === "applied") {
              console.log("mentors: ", jsonData["payload"]["mentors"]);
              let appliedMentors = [];
              for (let i = 0; i < jsonData["payload"]["mentors"].length; ++i) {
                appliedMentors.push(jsonData["payload"]["mentors"][0]["mentor_id"]);
              }
              setMentorAppliedRequests(appliedMentors);
              // {"action": "mentor", "payload": {"type": "applied", "mentors": [{"mentor_id": "ap-south-1_EH6LoIlGK:61fe920d-1dea-44c2-a727-ec6ea18a3389", "message": "asds"}]}}
            }
            else if (jsonData["payload"]["type"] === "list") {
              if (jsonData["payload"]["members"] && jsonData["payload"]["members"].length > 0) {
                setMentorRequests([...jsonData["payload"]["members"]]);
                console.log("setting memebers applied for mentoring");
                // /console.log(jsonData["payload"]["members"][0]["user_id"]);
              }
              else {
                setMentorRequests([]);
              }
            }
          }
          break;
        case "sales":
          console.log("------ sales -------");
          console.log("jsonData[payload]: ", jsonData["payload"]);
          if (jsonData["payload"]["type"]) {
            if (jsonData["payload"]["type"] === "applied") {
              console.log("Action: Sales: type: applied");
              console.log(jsonData["payload"]["saless"]);
            }
            else if (jsonData["payload"]["type"] === "list") {
              console.log(jsonData["payload"]["members"]);
              setSalesVideoCallMembers(jsonData["payload"]["members"]);
              setSalesVideoCallMembersNames(jsonData["payload"]["members_names"]);
            }
            else if (jsonData["payload"]["type"] === "enqueue") {
              console.log("Action: Sales: type: enqueue");
            }
            else if (jsonData["payload"]["type"] === "dequeue") {
              console.log("Action: Sales: type: dequeue");
            }
            else if (jsonData["payload"]["type"] === "accept") {
              setSalesPersonCalling(jsonData["payload"]["sales"]);
              setSalesPersonCallingName(jsonData["payload"]["sales_name"]);
              setShowSalesVideoCallNotification(true);

              setVideoCallWaiting(false);
              setVideoCallWaitingQueuePosition(0);
              setVideoCallWaitingQueueSize(0);
            }
            else if (jsonData["payload"]["type"] === "reject") {
              setVideoCallWaiting(false);
              setVideoCallWaitingQueuePosition(0);
              setVideoCallWaitingQueueSize(0);
            }
            else if (jsonData["payload"]["type"] === "queue") {
              console.log("queue: ", jsonData["payload"]);
              setVideoCallWaitingQueuePosition(jsonData["payload"]["pos"]);
              setVideoCallWaitingQueueSize(jsonData["payload"]["total"]);
            }
          }
          break;

          if (jsonData["payload"]["type"]) {

          }
      }
    };
  };

  const closeWebSocketConnection = () => {
    if (webSocketClient != null) {
      webSocketClient.close();
    }

    if (pingTimer) {
      clearInterval(pingTimer);
      setPingTimer(null);
    }
  };

  const sendChat = (to, message) => { // to and message in props
    console.log("sendChat 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      console.log("sendChat 2: to: ", to);
      const data = { "action": "sendmessage", "payload": { "to": to, "body": message, "type": "chat" } };
      webSocketClient.send(JSON.stringify(data));

      const msg = new Message({ id: 0, message: message });
      if (chatMessages[to] === undefined)
        chatMessages[to] = [];
      chatMessages[to].push(msg);

      const msgs = [...chatMessages[to]];
      setNewMessages(msgs);

      return true;
    }

    return false;
  };

  const sendGetListForMentoring = () => {
    console.log("sendGetListForMentoring 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      let profileData = JSON.parse(window.localStorage.getItem("profile"));

      const data = { "action": "mentor", "payload": { "mentor": profileData["user_id"], "type": "list" } };
      webSocketClient.send(JSON.stringify(data));
    };
  };

  const sendGetSalesVideoCallQueue = (sales_user_id) => {
    console.log("sendGetSalesVideoCallQueue");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      const data = { "action": "sales", "payload": { "sales": sales_user_id, "type": "list" } };
      webSocketClient.send(JSON.stringify(data));
    };
  };

  const applyForMentoring = (to, message) => {
    console.log("applyForMentoring 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      const data = {
        "action": "mentor",
        "payload": {
          "mentor": to,
          "type": "enqueue",
          "message": message
        }
      };
      webSocketClient.send(JSON.stringify(data));

      getListOfAppliedMentoring();

      return true;
    }

    return false;
  };

  const applyForSalesVideoCall = (to) => {
    console.log("applyForSalesVideoCall 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      const data = {
        "action": "sales",
        "payload": {
          "type": "enqueue",
          "sales": to
        }
      };
      webSocketClient.send(JSON.stringify(data));

      setVideoCallWaiting(true);
      // sendGetSalesVideoCallQueue(to);
      appliedForSalesVideoCall();

      return true;
    }

    return false;
  };

  const appliedForSalesVideoCall = () => {
    console.log("appliedForSalesVideoCall 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      const data = {
        "action": "sales",
        "payload": {
          "type": "applied"
        }
      };
      webSocketClient.send(JSON.stringify(data));

      return true;
    }

    return false;
  };

  const acceptAttendeeForMentoring = (to, action) => {
    console.log("acceptAttendeeForMentoring 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      let profileData = JSON.parse(window.localStorage.getItem("profile"));
      console.log("acceptAttendeeForMentoring 2: to: ", to);
      const data = {
        "action": "mentor",
        "payload": {
          "attendee": to,
          "type": action
        }
      };
      webSocketClient.send(JSON.stringify(data));

      return true;
    }

    return false;
  };

  const acceptAttendeeForSalesCall = (to, action) => {
    console.log("acceptAttendeeForSalesCall 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      let profileData = JSON.parse(window.localStorage.getItem("profile"));
      console.log("acceptAttendeeForSalesCall 2: to: ", to);
      const data = {
        "action": "sales",
        "payload": {
          "attendee": to,
          "type": action
        }
      };
      webSocketClient.send(JSON.stringify(data));

      setSalesPersonCalling(profileData["user_id"]);
      setSalesPersonCallingName(to);

      return true;
    }

    return false;
  };

  const getListOfAppliedMentoring = () => {
    console.log("getListOfAppliedMentoring 1");
    if (webSocketClient && webSocketClient.readyState === WebSocket.OPEN) {
      console.log("getListOfAppliedMentoring 2");
      const data = {
        "action": "mentor",
        "payload": {
          "type": "applied"
        }
      };
      webSocketClient.send(JSON.stringify(data));

      return true;
    }

    return false;
  };

  const loadPreviousMessages = (to) => {
    if (chatMessages[to] === undefined)
      chatMessages[to] = [];
    const msgs = [...chatMessages[to]];
    setNewMessages(msgs);
  };

  const onNewPasswordRequired = () => {
    history.push('/setpassword');
  };

  const onAuthSuccess = (needToThrow = true) => {
    setAuthSuccess(true);
  };

  const onAuthFailure = () => {
    setAuthSuccess(false);
  };

  const showBusinessCard = (step) => {
    setBusinessCardStep(step);
    setCreateBusinessCard(false);
  };

  const closeBusinessCard = () => {
    setCreateBusinessCard(false);
  };

  const onSignUpSuccess = () => {
    // console.log("onSignUpSuccess");
    // console.log(props);
    history.push('/verifyemail');
  };

  const onVerifyEmailSuccess = () => {
    console.log("onVerifyEmailSuccess");
    //checkIsAuthenticated();
  };

  const onForgotPasswordSuccess = () => {

  };

  const onResetPasswordSuccess = () => {

  };

  async function checkIsAuthenticated() {
    try {
      let user = await Auth.currentAuthenticatedUser();
      setAuthSuccess(true);
    }
    catch (error) {
      console.log("error in auth checking");
      setAuthSuccess(false);
    }
  };

  const [authSuccess, setAuthSuccess] = useState(false);

  useEffect(() => {
    async function checkAuth() {
      console.log("useEffect");
      try {
        const token = window.localStorage.getItem("token");
        if (token) {
          onAuthSuccess(false);
        }
      }
      catch (error) {
        console.log("error in authchecking");
        setAuthSuccess(false);
      }
    };

    const parsed = queryString.parse(window.location.search);
    console.log("parsed: ", parsed);
    if (parsed["token"] && parsed["username"]) {
      setVerifyEmailMode(true);
      setForgotPasswordMode(false);
      settoken(parsed["token"]);
      setusername(parsed["username"]);
    }
    else if (parsed["forgottoken"] && parsed["username"]) {
      setVerifyEmailMode(false);
      setForgotPasswordMode(true);
      settoken(parsed["forgottoken"]);
      setusername(parsed["username"]);
    }
    else if (parsed["paypal"]) {
      setPaypalMode(true);
    }
    else {
      checkAuth();
    }
  }, []);

  const handleSignOut = async () => {
    try {
      // closeWebSocketConnection();
      setInProcessUser(null);
      window.localStorage.setItem("authToken", null);
      // await Auth.signOut();
      setAuthSuccess(false);
      console.log("called replace");
    } catch (error) {
      console.log('error signing out: ', error);
      setAuthSuccess(false);
    }
  };

  const handleNotificationClose = () => {
    setShowNotification(false);
  };

  const showNotificationForNewChatMessage = (message) => {
    enqueueSnackbar(message, { anchorOrigin: { vertical: "bottom", horizontal: "right" }, variant: "info" });
  };

  const takeMentorCall = () => {
    console.log("takeMentorCall");
    // history.push("/mentoringrooms");

    window.localStorage.setItem("twilioRoomName", "12345678");
    setShowNotification(false);
    setShowMentorVideo(true);
  };

  const takeExhibitorVideoCall = () => {
    console.log("takeExhibitorVideoCall");
    setShowSalesVideoCallNotification(false);
    setShowSalesVideoCall(true);
  }

  const closeVideoApp = () => {
    console.log("closeVideoApp func called");
    setShowMentorVideo(false);
    setShowNetworkingVideo(false);
    setShowSalesVideoCall(false);
    setShowSalesVideoCallNotification(false);
  };

  const joinNetworkingRoom = (inRoomName) => {
    setRoomName(inRoomName);
    setShowNetworkingVideo(true);
  };

  const sendAcceptForMentoring = (user_id) => {
    console.log("sendAcceptForMentoring");
    acceptAttendeeForMentoring(user_id, "accept");

    window.localStorage.setItem("twilioRoomName", "12345678");

    setShowMentorVideo(true);
  };

  const sendRejectForMentoring = (user_id) => {
    console.log("sendRejectForMentoring");
    acceptAttendeeForMentoring(user_id, "reject");
  };

  const sendAcceptForSalesCall = (user_id) => {
    console.log("sendAcceptForMentoring");
    acceptAttendeeForSalesCall(user_id, "accept");

    window.localStorage.setItem("twilioRoomName", "12345678");
    setShowSalesVideoCall(true);
  };

  const sendRejectForSalesCall = (user_id) => {
    console.log("sendRejectForMentoring");
    acceptAttendeeForSalesCall(user_id, "reject");
  };

  return (
    <React.Fragment>
      <FullScreen handle={fullScreenHandle}>
        <main>
          {/* {authSuccess && <SSWebSocket chatMessage={chatMessage} />} */}
          <div className={classes.root}>
            {
              verifyEmailMode &&
              <BrowserRouter>
                <Switch>
                  <Route exact path="/verify-email" render={(props) => <VerifyEmail onVerifyEmailSuccess={onVerifyEmailSuccess} token={token} username={username} {...props} />} />
                  {<Route exact path="/verify-email.html" render={(props) => <VerifyEmail token={token} username={username} {...props} />} />}
                  <Redirect to="/verify-email" />
                </Switch>
              </BrowserRouter>

            }
            {
              forgotPasswordMode &&
              <BrowserRouter>
                <Switch>
                  <Route exact path="/reset-password" render={(props) => <ResetPasswordFromForgot token={token} username={username} {...props} />} />
                  {<Route exact path="/reset-password.html" render={(props) => <ResetPasswordFromForgot token={token} username={username} {...props} />} />}
                  <Redirect to="/reset-password" />
                </Switch>
              </BrowserRouter>

            }
            {
              paypalMode &&
              <BrowserRouter>
                <Switch>
                  <Route exact path="/tipjar" render={(props) => <TipJar  {...props} />} />
                  {<Route exact path="/tipjar.html" render={(props) => <TipJar  {...props} />} />}
                  <Redirect to="/tipjar" />
                </Switch>
              </BrowserRouter>

            }

            {!authSuccess && !verifyEmailMode && !forgotPasswordMode && !paypalMode &&
              <BrowserRouter>
                <Switch>
                  <Route exact path="/signin" render={(props) => <SignInSide onAuthSuccess={onAuthSuccess} onNewPasswordRequired={onNewPasswordRequired} setInProcessUser={setInProcessUser} {...props} />} />
                  {/* <Route exact path="/signup" render={(props) => <SignUpSide onSignUpSuccess={onSignUpSuccess} {...props} />} /> */}
                  <Route exact path="/verifyemail" render={(props) => <VerifyEmail onVerifyEmailSuccess={onVerifyEmailSuccess} {...props} />} />
                  <Route exact path="/forgotpassword" render={(props) => <ForgotPassword onForgotPasswordSuccess={onForgotPasswordSuccess} {...props} />} />
                  <Route exact path="/resetpassword" render={(props) => <ResetPassword onResetPasswordSuccess={onResetPasswordSuccess} {...props} />} />
                  {inProcessUser && <Route exact path="/setpassword" render={(props) => <SetPassword onAuthSuccess={onAuthSuccess} inProcessUser={inProcessUser} {...props} />} />}
                  {<Route exact path="/verify-email.html" render={(props) => <VerifyEmail  {...props} />} />}
                  <Route exact path="/index.html" render={(props) => <SignInSide onAuthSuccess={onAuthSuccess} onNewPasswordRequired={onNewPasswordRequired} setInProcessUser={setInProcessUser} {...props} />} />
                  <Redirect to="/signin" />
                </Switch>
              </BrowserRouter>
            }

            {!verifyEmailMode && !forgotPasswordMode && authSuccess && !paypalMode &&
              < BrowserRouter >
                <NavBar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} handleSignOut={handleSignOut} showBusinessCard={showBusinessCard} fullScreenHandleEnter={fullScreenHandle.enter} videoCallWaiting={videoCallWaiting} videoCallWaitingQueueSize={videoCallWaitingQueueSize} videoCallWaitingQueuePosition={videoCallWaitingQueuePosition} />
                <ResponsiveDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isSalesMen={isSalesMen} isExhibitor={isExhibitor} isManagePanels={isSalesMen || isExhibitor} themeChangedInApp={themeChanged} />
                <Switch>
                  <Route exact path="/not-found" component={NotFound} />
                  {<Route exact path="/verify-email.html" render={(props) => <VerifyEmail  {...props} />} />}
                  {/* {<Route exact path="/index.html" render={(props) => <div className={clsx(drawerOpen ? classes.open : classes.close, dir === 'rtl' ? classes.right : classes.left)}> <Procurements refreshUI={refreshUI} onAuthFailure={onAuthFailure} adminRole={adminRole} setProcurement={setProcurement}  {...props} /> </div>} />} */}
                  <Route exact path="/inviteswaiting" render={(props) => <div className={clsx(drawerOpen ? classes.open : classes.close, dir === 'rtl' ? classes.right : classes.left)}> <Invites refreshUI={refreshUI} onAuthFailure={onAuthFailure} setSelectedUser={setSelectedUser} {...props} /> </div>} />
                  <Route exact path="/promotioninvites" render={(props) => <div className={clsx(drawerOpen ? classes.open : classes.close, dir === 'rtl' ? classes.right : classes.left)}> <PromotionInvites refreshUI={refreshUI} onAuthFailure={onAuthFailure} {...props} /> </div>} />
                  <Route exact path="/pushnotifications" render={(props) => <div className={clsx(drawerOpen ? classes.open : classes.close, dir === 'rtl' ? classes.right : classes.left)}> <PushNotifications refreshUI={refreshUI} onAuthFailure={onAuthFailure} {...props} /> </div>} />

                  <Route exact path="/" render={(props) => <div className={clsx(drawerOpen ? classes.open : classes.close, dir === 'rtl' ? classes.right : classes.left)}> <Users refreshUI={refreshUI} onAuthFailure={onAuthFailure} handleSignOut={handleSignOut} setSelectedUser={setSelectedUser} {...props} /> </div>} />
                  <Route exact path="/index.html" render={(props) => <div className={clsx(drawerOpen ? classes.open : classes.close, dir === 'rtl' ? classes.right : classes.left)}> <Users refreshUI={refreshUI} onAuthFailure={onAuthFailure} handleSignOut={handleSignOut} setSelectedUser={setSelectedUser} {...props} /> </div>} />
                  <Route render={() => <Redirect to="/index.html" />} />
                </Switch>
              </BrowserRouter>
            }

            {/* {
              authSuccess && createBusinessCard && <BusinessCard onAuthFailure={onAuthFailure} closeBusinessCard={closeBusinessCard} businessCardStep={businessCardStep} />
            } */}

          </div>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={showNotification} autoHideDuration={60000} >
            <Alert onClose={handleNotificationClose} severity="info">
              <AlertTitle>Mentor calling</AlertTitle>
              {/* <strong>check it out!</strong> {notificationMessage} */}
              <Button onClick={takeMentorCall}>Attend video call with Mentor</Button>
            </Alert>
          </Snackbar>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={showSalesVideoCallNotification} autoHideDuration={60000} >
            <Alert onClose={handleNotificationClose} severity="info">
              <AlertTitle>Exhibitor Video call!!</AlertTitle>
              {/* <strong>check it out!</strong> {notificationMessage} */}
              <Button onClick={takeExhibitorVideoCall}>Join video call with {salesPersonCallingName}</Button>
            </Alert>
          </Snackbar>

        </main>
      </FullScreen>
      {/* <Fab style={{ position: 'absolute', top: '50%', right: 10 }} color="primary" aria-label="add">
        <AddIcon />
      </Fab> */}


    </React.Fragment >
  );
}

export default App;
